export default __webpack_public_path__ + "static/media/cy_logo_mob.d866224e.svg";